import { Link } from 'react-router-dom';
import { PATHS } from '@/routes';
import { useAuthStore } from '@/modules/Login/store';
import { getDefaultHomePath } from '@/modules/Login/utils/navigation-permissions';
import { useMemo } from 'react';

const NotFoundPage = () => {
	const hasPermission = useAuthStore(state => state.hasPermission);
	const isAuthenticated = useAuthStore(state => Boolean(state.user));

	const fallbackPath = useMemo(
		() => (isAuthenticated ? getDefaultHomePath(hasPermission) : PATHS.LOGIN),
		[hasPermission, isAuthenticated],
	);

	return (
		<div className="min-h-screen w-full bg-gradient-to-br from-slate-900 via-slate-800 to-slate-950 text-white flex items-center justify-center px-4 py-10">
			<div className="max-w-xl text-center space-y-8">
				<div className="relative inline-flex">
					<div className="text-[140px] leading-none font-black tracking-widest text-white drop-shadow-[0_5px_35px_rgba(59,130,246,0.45)]">
						404
					</div>
					<div className="absolute inset-0 blur-3xl bg-gradient-to-r from-sky-500/40 via-cyan-400/40 to-blue-500/40 animate-pulse" />
				</div>

				<div className="space-y-3">
					<h1 className="text-3xl font-bold">Página no encontrada</h1>
					<p className="text-base text-slate-200/80">
						Lo sentimos, no tienes acceso o la página que buscas no existe.
					</p>
				</div>

				<div className="flex items-center justify-center gap-4">
					<Link
						to={fallbackPath}
						className="px-6 py-3 rounded-full bg-sky-500 text-white font-semibold shadow-lg shadow-sky-500/40 hover:bg-sky-400 transition-colors">
						Ir al inicio
					</Link>
					<button
						type="button"
						onClick={() => window.history.back()}
						className="px-6 py-3 rounded-full border border-white/30 font-semibold text-white/90 hover:border-white hover:text-white transition-colors">
						Volver atrás
					</button>
				</div>
			</div>
		</div>
	);
};

export default NotFoundPage;
